import React, { useEffect } from "react";
import { Outlet, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { IoMdArrowRoundBack } from "react-icons/io";
import BISidebar from "../../components/BI/BISidebar";

export function InteligenciaNegociosPage() {
  const biState = useSelector((state) => state.bi);

  // Check if any BI section is loading
  const isAnyLoading =
    biState?.inventario?.loading ||
    biState?.inventarioResumen?.loading ||
    biState?.ventasDiarias?.loading ||
    biState?.clientesInactivos?.loading ||
    biState?.apertura?.loading ||
    biState?.comparativo?.loading ||
    biState?.transferencias?.loading;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full px-4 md:px-6 lg:px-8 xl:px-10 pb-16 min-h-[400px]">
      {/* Header with back button */}
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <h2 className="text-lg font-bold text-gray-800">Inteligencia de Negocios</h2>
          {isAnyLoading && (
            <div className="flex items-center gap-2 text-sm text-gray-500">
              <svg className="animate-spin h-4 w-4 text-purple" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              <span>Cargando...</span>
            </div>
          )}
        </div>
        <Link to="/cuenta">
          <button className="bg-pink text-white py-2 px-6 font-bold rounded-full flex items-center gap-1 text-sm">
            <IoMdArrowRoundBack className="text-base" /> Volver
          </button>
        </Link>
      </div>

      {/* Horizontal tab navigation */}
      <BISidebar />

      {/* Full-width content area */}
      <div className="mt-4">
        <Outlet />
      </div>
    </div>
  );
}

export default InteligenciaNegociosPage;
